export default __webpack_public_path__ + "static/media/NotoSans-Bold.ba396a9f.woff";